// extracted by mini-css-extract-plugin
export default {"root__container":"AccountStatus_root__container__QnBB7","title__home":"AccountStatus_title__home__9HwUc"};